import { addMessages } from '@hana/i18n';

// Khoá chuỗi của hộp thoại thao tác theo đối tác (AgentModal.tsx). Nội dung thư mẫu và tên đối tác không dịch.
addMessages('vi', {
  'am.noWrite': 'Chưa bật ghi yêu cầu hỏi giá',
  'am.use': 'Dùng {k}',
  'am.carrier': 'Hãng',
  'am.orig': 'Giá gốc',
  'am.usd': 'Quy USD (VCB bán)',
  'am.valid': 'Hiệu lực',
  'am.aiTitle': 'Nháp giá từ mail · {name}',
  'am.aiLead': 'Ask HANA đọc mail trả lời và điền nháp. Bỏ tick ô không đúng rồi ghi.',
  'am.cancel': 'Huỷ',
  'am.save': 'Ghi giá',
  'am.priceTitle': 'Ghi giá đối tác chào · {name}',
  'am.priceLead': 'Nhập tay khi đối tác báo qua điện thoại / Zalo. Tiền khác USD tự quy theo VCB bán.',
  'am.cur': 'Tiền tệ',
  'am.allin': 'All-in',
  'am.transit': 'Transit',
  'am.until': 'Hiệu lực đến',
  'am.threadTitle': 'Thư với {name}',
  'am.threadLead': 'Luồng thư lấy từ pricing@ và hộp của chủ yêu cầu.',
  'am.fwd': 'Chuyển tiếp',
  'am.reply': 'Trả lời',
  'am.winTitle': 'Chọn {name} cho {inq}?',
  'am.winLead': 'Ghi đối tác thắng vào timeline CRM của đối tác và báo các đối tác còn lại (tuỳ chọn). Đổi lại được bằng Hoàn tác.',
  'am.pick': 'Chọn đối tác',
});
addMessages('en', {
  'am.noWrite': 'Writing rate inquiries is not enabled',
  'am.use': 'Use {k}',
  'am.carrier': 'Carrier',
  'am.orig': 'Original rate',
  'am.usd': 'In USD (VCB sell)',
  'am.valid': 'Validity',
  'am.aiTitle': 'Rate draft from mail · {name}',
  'am.aiLead': 'Ask HANA reads the reply mail and fills a draft. Untick wrong fields, then save.',
  'am.cancel': 'Cancel',
  'am.save': 'Save rate',
  'am.priceTitle': 'Record partner offer · {name}',
  'am.priceLead': 'Enter manually when the partner quotes by phone / Zalo. Non-USD currencies convert at the VCB sell rate.',
  'am.cur': 'Currency',
  'am.allin': 'All-in',
  'am.transit': 'Transit',
  'am.until': 'Valid until',
  'am.threadTitle': 'Mail with {name}',
  'am.threadLead': 'Thread comes from pricing@ and the requester’s mailbox.',
  'am.fwd': 'Forward',
  'am.reply': 'Reply',
  'am.winTitle': 'Select {name} for {inq}?',
  'am.winLead': 'Records the winning partner on the partner’s CRM timeline and optionally notifies the others. Reversible with Undo.',
  'am.pick': 'Select partner',
});
